import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { decodeHTML, findTaxonomyObjectByID } from '../helpers';
import '../find-polyfill';

class TagList extends Component {

  reorderTagsByParent(tagList) {
    let newTagList = [];
    // Loop through tags to find parents
    for (let i=0; i<tagList.length; i++) {
      if (tagList[i].parent === 0) {
        newTagList.push(tagList[i]);

        // Now loop again to find this parent's children
        for (let j=0; j<tagList.length; j++) {
          if (tagList[j].parent === tagList[i].id) {
            newTagList.push(tagList[j]);
          }
        }
      }
    }

    // Loop once more to find any children without parents
    for (let i=0; i<tagList.length; i++) {
      if (newTagList.indexOf(tagList[i]) === -1) {
        newTagList.push(tagList[i]);
      }
    }

    return newTagList;
  }

  render() {
    let post = this.props.post;
    
    // Make a nice, simple array of tags for use in the return.
    let tagList = [];
    if (typeof post.topics !== 'undefined' && post.topics.length > 0) { // Add topics to tag list
      // Get the topics from wpData
      function istopics(obj) { return obj.name === 'topics'; }
      let wpTopics = this.props.wpData.taxonomies.find(istopics);
      
      for (let i=0; i<post.topics.length; i++) {
        // Get the individual issue we're seeking and add it to the array
        let issueID = post.topics[i];
        function isIssue(obj) { return obj.id === issueID; }
        let issue = wpTopics.terms.find(isIssue);
        if (typeof issue !== 'undefined') {
          let issueClassName = issue.slug;
          if (issue.parent !== 0) { // Check if child issue term (for color application purposes they get the same class name as their parent)
            let issueParent = findTaxonomyObjectByID(issue.parent, wpTopics.terms);
            if (typeof issueParent !== 'undefined') {
              issueClassName = issueParent.slug;
            }
          }
          tagList.push({
            'id': issue.id,
            'parent': issue.parent,
            'type': 'topics',
            'name': decodeHTML(issue.name),
            'link': issue.link,
            'slug': issue.slug,
            'className': issueClassName,
          });

          // Reorder tagList by parent
          tagList = this.reorderTagsByParent(tagList);
        }
      }
    }

    if (typeof post.capability !== 'undefined' && post.capability.length > 0) { // Add capabilities to tag list
      // Get the capabilities from wpData
      function isCapabilities(obj) { return obj.name === 'capability'; }
      let wpCapabilities = this.props.wpData.taxonomies.find(isCapabilities);
      
      for (let i=0; i<post.capability.length; i++) {
        // Get the individual issue we're seeking and add it to the array
        let capabilityID = post.capability[i];
        function isCapability(obj) { return obj.id === capabilityID; }
        let capability = wpCapabilities.terms.find(isCapability);
        tagList.push({
          'type': 'capability',
          'name': decodeHTML(capability.name),
          'link': capability.link,
          'slug': capability.slug,
          'className': 'capability'
        });
      }
    }

    return (
      <ul className="post__tag-list tag-list">
        {tagList.map((tag, index) => // Loop through pets and display them
          <li key={index} className={'tag-list__tag  tag-list__tag--' + tag.className}><a href={tag.link}>{tag.name}</a></li>
        )}
      </ul>
    );
  }
};

TagList.propTypes = {
  post: PropTypes.object,
  wpData: PropTypes.object,
};

export default TagList;


// WEBPACK FOOTER //
// ./src/components/TagList.js